import axios from "axios";
import { getCookie, setCookie } from "./cookie";
import { getCookie as getRawCookie, setCookie as setRawCookie, deleteCookie as deleteRawCookie } from "../utils/cookie";
import apiRoutes from "../api/api_route";

export const handleAuthentication = async (errorConfig) => {
  if (errorConfig?.config?.url.includes("refreshToken")) {
    window.location.reload();
    resetDataAndLogout();
  } else {
    return await getRefreshToken(errorConfig);
  }
};

export const getRefreshToken = async (errorConfig) => {
  const currentRefreshToken = getRawCookie("refreshToken");
  try {
    const headerToken = `Bearer ${currentRefreshToken}`;

    const refreshTokenResult = await axios.post(
      apiRoutes.auth.refreshToken,
      {},
      {
        headers: {
          Authorization: headerToken,
        },
      }
    );

    if (refreshTokenResult?.data) {
      try {
        await setLoginCookies(refreshTokenResult.data);
        return true;
      } catch (err) {
        console.log(err);
      }
    } else {
      window.location.href = "/";
      return false;
    }
  } catch (error) {
    const newRefreshToken = getRawCookie("refreshToken");
    if (newRefreshToken && newRefreshToken !== currentRefreshToken) {
      return true;
    }

    resetDataAndLogout();
    window.location.href = "/";
    return false;
  }
};

export const setLoginCookies = async (user) => {
  try {
    const defaultExpires = 30 * 60;
    if (!user || !user.accessToken) {
      throw new Error("Invalid user object or missing tokens");
    }

    const accessToken = String(user.accessToken || user.token);
    const refreshToken = String(user.refreshToken);
    const accessExpiresIn = String(user.accessExpiresIn || 1800);
    const refreshExpiresIn = String(user.refreshExpiresIn || 2400);

    const accessExpiration = Number(user.accessExpiresIn) || defaultExpires;
    const refreshExpiration = Number(user.refreshExpiresIn) || defaultExpires * 48;

    setRawCookie("accessToken", accessToken, accessExpiration / 86400);
    setRawCookie("refreshToken", refreshToken, refreshExpiration / 86400);
    setRawCookie("accessExpiresIn", accessExpiresIn, accessExpiration / 86400);
    setRawCookie("refreshExpiresIn", refreshExpiresIn, refreshExpiration / 86400);
  } catch (err) {
    console.error("[setLoginCookies] Error setting login cookies:", err);
    throw err;
  }
};

export const resetDataAndLogout = () => {
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      ?.replace(/^ +/, "")
      ?.replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
};
